<template>
  <div
    class        = "c-points-record"
    v-bind:class = "{ 'is-expanded' : showNotes  }"
  >



    <div class="c-points-record__overview">

      <div class="c-points-record__overview__numbers">
        <h5 class="c-points-record__overview__numbers__date u-number-font">
          {{ pointsRecord.created_at }}
        </h5>
        <h6 class="c-points-record__overview__numbers__points u-number-font">
          <span class="t-positive" v-if="pointsRecord.points > 0">+</span>
          <span class="t-negative" v-if="pointsRecord.points < 0">-</span>
          {{ formatNumber(Math.abs(pointsRecord.points)) }}
        </h6>
      </div>

      <div class="c-points-record__overview__headline">
        <h4 class="c-points-record__overview__headline__program">
          <span v-if="pointsRecord.source === 'redemption'">
            {{ $t('web.points_record.order_number', {order_number: pointsRecord.order_number}) }}
          </span>
          <span v-else-if="pointsRecord.source === 'refund'">
            {{ $t('web.points_record.refund_label') }}
          </span>
          <span v-else>
            {{ pointsRecord.program_name }}
          </span>
        </h4>
        <h5 class="c-points-record__overview__headline__rule">
          {{ !pointsRecord.order_number ? pointsRecord.description : '' }}
        </h5>
        <div class = "c-points-record__overview__maths" v-if  = "pointsRecord.source === 'refund'">
          {{ $t('web.points_record.refund_details', {order_number: pointsRecord.order_number, order_notes: pointsRecord.order_notes}) }}
        </div>
      </div>

    </div>



    <div class="c-points-record__notes">

      <div
        class  = "c-points-record__notes__text"
        v-if   = "pointsRecord.notes && showNotes"
      >
        <h5 class="c-points-record__notes__text__headline">{{ $t('web.points_record.notes_label') }}</h5>
        <p class="u-small-paragraph">{{ pointsRecord.notes }}</p>
      </div>

      <div class="c-points-record__notes__actions">
        <button
          class  = "c-points-record__notes__actions__link t-button-borderless"
          v-if   = "pointsRecord.notes"
          @click = "toggleNotes"
        >
          {{ $t('web.points_record.notes_toggle') }}
          <span class="c-points-record__notes__actions__link__icongroup">
            <i v-if="!showNotes" class="fa fa-chevron-down is-collapsed"></i>
            <i v-if="showNotes" class="fa fa-chevron-up is-expanded"></i>
          </span>
        </button>
        <a
          class  = "c-points-record__notes__actions__link t-button-borderless"
          v-if   = "pointsRecord.order_number"
          @click = "goToPage('MyOrders')"
        >
          {{ $t('web.points_record.orders_link') }}
          <i class="fa fa-long-arrow-right"></i>
        </a>
      </div>

    </div>



  </div>
</template>





<script>

/* HTML */
import { mapGetters } from 'vuex'
import util from '@/functions'

export default {
  name: 'PointsRecord',
  props: ['pointsRecord'],
  computed: {
    ...mapGetters([
      'points',
      'participant'
    ])
  },
  data () {
    return {
      showNotes: false
    }
  },
  methods: {
    formatNumber (value) {
      return util.formatNumber(value)
    },
    goToPage (page) {
      util.togglePointsLedger(false)
      this.$router.push({ name: page })
    },
    toggleNotes () {
      this.showNotes = !this.showNotes
    }
  }
}
</script>


<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// PointsRecord.vue?62952b70